module.exports = __webpack_public_path__ + "img/日用雑貨・食品・サプリメント等の輸出販売.97615cd7.png";